import React, { ReactNode } from "react";
import {
     Box,
     Dialog,
     DialogActions,
     DialogContent,
     DialogTitle,
     IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface BaseDialogProps {
     open: boolean;
     title: string;
     maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
     fullWidth?: boolean;
     showCloseButton?: boolean;
     showDivider?: boolean;
     disabled?: boolean;
     children: ReactNode;
     actions?: ReactNode;
     onClose: () => void;
}

export const BaseDialog: React.FC<BaseDialogProps> = ({
     open,
     title,
     maxWidth = "xs",
     fullWidth = true,
     showCloseButton = false,
     showDivider = true,
     disabled = false,
     children,
     actions,
     onClose,
}) => {
     const handleClose = (event: {} | React.MouseEvent<HTMLButtonElement>, reason?: "backdropClick" | "escapeKeyDown") => {
          if (!disabled) {
               onClose();
          }
     };

     return (
          <Dialog 
               open={open} 
               onClose={handleClose} 
               maxWidth={maxWidth} 
               fullWidth={fullWidth}
               disableEscapeKeyDown={disabled}
          >
               <DialogTitle>
                    {showCloseButton ? (
                         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <span>{title}</span>
                              <IconButton
                                   aria-label="close"
                                   onClick={handleClose}
                                   disabled={disabled}
                                   sx={{
                                        color: (theme) => theme.palette.grey[500],
                                        "&:hover": {
                                             backgroundColor: (theme) => theme.palette.grey[100],
                                        },
                                   }}
                              >
                                   <CloseIcon />
                              </IconButton>
                         </Box>
                    ) : (
                         title
                    )}
               </DialogTitle>
               {showDivider && (
                    <Box
                         sx={{
                              width: "100%",
                              height: "1px",
                              backgroundColor: "#e0e0e0",
                         }}
                    />
               )}
               <DialogContent>{children}</DialogContent>
               {actions && <DialogActions>{actions}</DialogActions>}
          </Dialog>
     );
};
